import { useEffect } from "react"
import { Platform } from "react-native"
import { useNavigationContainerRef } from "expo-router"
import * as Sentry from "@sentry/react-native"
import config from "@/config"

const routingInstrumentation = Sentry.reactNavigationIntegration({
  enableTimeToInitialDisplay: true,
})

const isBrowserEnv = () => typeof window !== `undefined`

const shouldEnableSentry = () => {
  if (process.env.JEST_WORKER_ID !== undefined) {
    return false
  }

  if (Platform.OS === "web") {
    return isBrowserEnv()
  }

  return true
}

Sentry.init({
  dsn: config.SENTRY_DSN,
  enabled: shouldEnableSentry(),
  environment: config.SENTRY_ENVIRONMENT,
  debug: false,
  tracesSampleRate: process.env.APP_VARIANT === "production" ? 0.5 : 1.0,
  enableCaptureFailedRequests: true,
  enableAutoSessionTracking: true,
  enableNdkScopeSync: true,
  attachScreenshot: !__DEV__ && Platform.OS !== "web",
  integrations: [routingInstrumentation],
})

const useSentry = () => {
  const ref = useNavigationContainerRef()

  useEffect(() => {
    if (ref) {
      routingInstrumentation.registerNavigationContainer(ref)
    }
  }, [ref])
}

const logoutSentryUser = () => {
  Sentry.setUser(null)
}

export { Sentry, useSentry, logoutSentryUser }
